import { t } from 'i18next';

import { BasicMaterial, MaterialTypeahead } from '~hooks/useMaterials/models';

import OptionCodePair from './OptionCodePair';

// Composes the secondary (under-the-name) line for material dropdown options.
// Renders `EXT. ID <code>` when present and (forward-ready) `ACCT <code>`
// once the typeahead serializer exposes accounting_id. Returns null when
// neither is available, leaving the option as a single-line render.
//
// The model getters are read at the call site (here, not inside SelectOption)
// so any bug from spreading or serializing a model upstream points back to a
// specific consumer rather than to a generic renderer.
type MaterialLike = (MaterialTypeahead | BasicMaterial) & {
  // accountingId is not on the typeahead model today, but consumers can pass
  // any model exposing the getter and the ACCT pair lights up automatically.
  readonly accountingId?: string | null;
};

export default function MaterialOptionSecondary({
  material,
  query,
}: {
  material: MaterialLike | null | undefined;
  query: string;
}) {
  const externalId = material?.externalId ?? '';
  const accountingId = material?.accountingId ?? '';

  if (!externalId && !accountingId) {
    return null;
  }

  return (
    <>
      {externalId && (
        <OptionCodePair
          label={t('form_fields.ext_id_short')}
          value={externalId}
          query={query}
        />
      )}
      {accountingId && (
        <OptionCodePair
          label={t('form_fields.acct_short')}
          value={accountingId}
          query={query}
        />
      )}
    </>
  );
}
